

import { TicketCreateForm } from './common/TicketForms';


export default function TicketCreate({selectedYear}){

  return (
    <>
      <div className="row">
        <h3 className="m-3">Создать обращение - задания</h3>
      </div>
      <p className='ms-3 mb-0'>Обращения по вопросам ввода данных исследований</p> 
      <p className='ms-3 mt-0'>По другим вопросам пожалуйста свяжитесь с АСНП ЦВКК по электронной почте <a href="mailto:labs@fsvok.ru">labs@fsvok.ru</a></p>
      <div className='m-3'>
        <TicketCreateForm
          year={selectedYear}
          queue={'forms'}
        />                       
    </div> 
    </>
  )
}